var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',{attrs:{"description":"component 마다 해당 header 다국어를 props받아 출력"}},[_vm._v(_vm._s(this.header))]),_c('span',{staticClass:"back_btn"},[_c('span',{on:{"click":function($event){return _vm.Back()}}},[_c('img',{attrs:{"src":require("../../mobile/img/back_btn.png"),"alt":"뒤로가기"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }